module.exports = __webpack_public_path__ + "img/mobile.d5f5faf1.svg";